import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { unregister } from './serviceWorker';
import 'react-table-6/react-table.css';
import 'bootstrap/dist/css/bootstrap.css';
import './Assets/Main.scss';
import App from './App';

if (process.env.NODE_ENV !== 'production') {
  axios.defaults.baseURL = 'http://localhost:8080/';
}

// if (process.env.NODE_ENV !== "production") {
//   const { whyDidYouUpdate } = require("why-did-you-update");
//   console.log('log')
//   whyDidYouUpdate(React);
// }

// if (process.env.NODE_ENV !== "production") {
//   const whyDidYouRender = require("@welldone-software/why-did-you-render");
//   whyDidYouRender(React, { include: [/.*/] });
// }

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
unregister();
